(function () {
  'use strict';

  var INIT_FLAG = 'b2bEnProductI18n';

  var COMMERCIAL_REPLACEMENTS = [
    ["Reso 30 giorni in Italia · 14 giorni all'estero", "Returns: 30 days in Italy · 14 days outside Italy"],
    ["Reso 30 giorni in Italia · 14 giorni estero", "Returns: 30 days in Italy · 14 days outside Italy"],
    ["Disponibile online – spedizione dal primo giorno utile", "Available online – shipping from the next available working day"],
    ["Disponibile – spedizione rapida", "Available – fast shipping"],
    ["Ordina entro le 13:00 nei giorni lavorativi: spedizione prevista in giornata*", "Order by 1:00 PM on working days: expected to ship the same day*"],
    ["Ordina entro le 13:00: spedizione prevista in giornata*", "Order by 1:00 PM: expected to ship the same day*"],
    ["Oggi non sono previste spedizioni. Prossima spedizione:", "No shipments are scheduled today. Next shipment:"],
    ["Ordini dopo le 13:00: spedizione prevista", "Orders after 1:00 PM: expected shipment"],
    ["*Salvo imprevisti, festività o chiusure straordinarie. Quando possibile spediamo anche ordini ricevuti dopo le 13:00.", "*Subject to unforeseen circumstances, public holidays or exceptional closures. Whenever possible, we also ship orders received after 1:00 PM."],
    ["*Gli ordini saranno evasi dal primo giorno lavorativo utile, salvo imprevisti.", "*Orders will be processed from the next available working day, subject to unforeseen circumstances."],
    ["*Chiusura:", "*Closure:"],
    ["Gli ordini saranno evasi alla riapertura, salvo imprevisti.", "Orders will be processed when the store reopens, subject to unforeseen circumstances."],
    ["*Stima prudente. Gli ordini ricevuti dopo le 13:00 vengono programmati per la prima spedizione utile. Quando possibile anticipiamo comunque l’evasione.", "*Conservative estimate. Orders received after 1:00 PM are scheduled for the next available shipment. Whenever possible, we dispatch earlier."],
    ["Spedizione GRATIS da €49", "FREE shipping from €49"],
    ["Spedizione GRATIS", "FREE shipping"],
    ["Reso 30 giorni", "Returns: 30 days"],
    ["Garanzia 24 mesi", "24-month warranty"],
    ["Paga a Rate con Klarna o PayPal", "Pay in instalments with Klarna or PayPal"],
    ["Ritiro e pagamento in negozio a Roma disponibili", "Store pickup and payment available in Rome"],
    ["Solo ritiro in negozio a Roma", "Store pickup only at our Rome store"],
    ["Esaurito online", "Sold out online"],
    ["Contattaci per riassortimento o alternative disponibili", "Contact us for restocking or available alternatives"],
    ["Condividi", "Share"],
    ["Link copiato", "Link copied"]
  ];

  var COMPACT_REPLACEMENTS = [
    ["Disponibile online", "Available online"],
    ["Acquistabile online", "Available online"],
    ["Prossima spedizione:", "Next shipment:"],
    ["Ordina entro ", "Order within "],
    [" · spedizione prevista oggi", " · expected to ship today"]
  ];

  var BENEFIT_REPLACEMENTS = [
    ["Spedizione gratuita in Italia da €49", "Free shipping in Italy from €49"],
    ["Spedizione gratuita in Italia", "Free shipping in Italy"],
    ["Reso 30 giorni in Italia", "30-day returns in Italy"],
    ["Negozio fisico", "Physical store"],
    ["Roma", "Rome"]
  ];

  var DELIVERY_REPLACEMENTS = [
    ["Stima consegna", "Delivery estimate"],
    ["Verifica la data indicativa in base al CAP", "Check the estimated date using your postal code"],
    ["Stima prudente", "Conservative estimate"],
    ["Inserisci il tuo CAP", "Enter your postal code"],
    ["Le date sono indicative e non costituiscono garanzia di consegna. Eventuali ritardi del corriere non dipendono da noi.", "Dates are estimates and do not constitute a delivery guarantee. Courier delays are outside our control."],
    ["Spedizione:", "Shipping:"],
    ["ordinando entro le", "if you order by"],
    ["l’ordine è previsto in partenza", "the order is expected to ship"],
    ["oggi stesso", "today"],
    ["salvo imprevisti", "subject to unforeseen circumstances"],
    ["oggi non sono previste partenze. Prossima spedizione", "no shipments are scheduled today. Next shipment"],
    ["per gli ordini ricevuti dopo le", "for orders received after"],
    ["la stima considera la partenza", "the estimate assumes shipment"],
    ["Quando possibile spediamo anche ordini ricevuti nel primo pomeriggio, fino alle", "Whenever possible, we also ship orders received in the early afternoon, until approximately"],
    ["14:00 circa", "2:00 PM"],
    ["in quel caso la consegna potrebbe anticipare.", "in that case delivery may be earlier."],
    ["la partenza stimata è", "the expected shipment date is"],
    ["Quando possibile anticipiamo l’evasione: la consegna potrebbe arrivare prima della data indicata.", "Whenever possible, we dispatch earlier: delivery may arrive before the estimated date."],
    ["Consegna stimata per CAP", "Estimated delivery for postal code"],
    ["CAP in isole o aree con tempi di consegna estesi.", "Postal code in an island or extended-delivery area."],
    ["Tempi estesi", "Extended timing"],
    ["Area con tempi di consegna standard.", "Standard delivery area."],
    ["Zona standard", "Standard area"],
    ["Consegna stimata", "Estimated delivery"],
    ["Isole e aree con tempi estesi:", "Islands and extended-delivery areas:"],
    ["Nota:", "Note:"],
    ["il negozio è chiuso per", "the store is closed for"],
    ["13:00", "1:00 PM"],
    ["14:00", "2:00 PM"]
  ];

  var DATE_REPLACEMENTS = [
    ["oggi", "today"], ["domani", "tomorrow"],
    ["Lunedì", "Monday"], ["lunedì", "Monday"],
    ["Martedì", "Tuesday"], ["martedì", "Tuesday"],
    ["Mercoledì", "Wednesday"], ["mercoledì", "Wednesday"],
    ["Giovedì", "Thursday"], ["giovedì", "Thursday"],
    ["Venerdì", "Friday"], ["venerdì", "Friday"],
    ["Sabato", "Saturday"], ["sabato", "Saturday"],
    ["Domenica", "Sunday"], ["domenica", "Sunday"],
    ["gennaio", "January"], ["febbraio", "February"], ["marzo", "March"],
    ["aprile", "April"], ["maggio", "May"], ["giugno", "June"],
    ["luglio", "July"], ["agosto", "August"], ["settembre", "September"],
    ["ottobre", "October"], ["novembre", "November"], ["dicembre", "December"]
  ];

  function isEnglishProductPage() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var path = window.location.pathname || '';
    return (lang.indexOf('en') === 0 || /^\/en(?:\/|$)/.test(path)) && /\/products\//.test(path);
  }

  function applyReplacements(value, replacements) {
    var output = String(value || '');
    replacements.forEach(function (pair) {
      if (output.indexOf(pair[0]) !== -1) {
        output = output.split(pair[0]).join(pair[1]);
      }
    });
    return output;
  }

  function translateTextNodes(root, replacements, includeDates) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentNode;
        if (!parent) return NodeFilter.FILTER_REJECT;
        var tag = parent.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var translated = applyReplacements(textNode.nodeValue, replacements);
      if (includeDates) translated = applyReplacements(translated, DATE_REPLACEMENTS);
      if (translated !== textNode.nodeValue) textNode.nodeValue = translated;
    });
  }

  function translateProductCopy() {
    if (!isEnglishProductPage()) return;

    document.querySelectorAll('[data-product-shipping-info-wrap], #shareBtn').forEach(function (root) {
      translateTextNodes(root, COMMERCIAL_REPLACEMENTS, true);
    });

    document.querySelectorAll('[data-delivery-estimate]').forEach(function (root) {
      translateTextNodes(root, COMMERCIAL_REPLACEMENTS.concat(DELIVERY_REPLACEMENTS), true);
      var zipInput = root.querySelector('[data-zip-input]');
      if (zipInput && zipInput.getAttribute('placeholder') === 'es. 09121') {
        zipInput.setAttribute('placeholder', 'e.g. 09121');
      }
    });

    document.querySelectorAll('[data-de-compact-view]').forEach(function (root) {
      translateTextNodes(root, COMMERCIAL_REPLACEMENTS.concat(COMPACT_REPLACEMENTS), true);
    });

    document.querySelectorAll('[data-pdp-purchase-benefits]').forEach(function (root) {
      translateTextNodes(root, BENEFIT_REPLACEMENTS, false);
    });

    /* Sold-out custom-liquid output has no wrapper, so translate only highly specific phrases. */
    var productRoot = document.querySelector('.product_section') || document.querySelector('[data-section-type="product-template"]');
    if (productRoot) translateTextNodes(productRoot, COMMERCIAL_REPLACEMENTS, false);
  }

  function initEnglishProductLocalization() {
    if (!isEnglishProductPage()) return;
    if (document.documentElement.dataset[INIT_FLAG]) return;
    document.documentElement.dataset[INIT_FLAG] = '1';

    translateProductCopy();

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        translateProductCopy();
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  window.PXUTheme = window.PXUTheme || {};
  window.PXUTheme.jsCustom = window.PXUTheme.jsCustom || {};
  window.PXUTheme.jsCustom.init = initEnglishProductLocalization;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnglishProductLocalization);
  } else {
    initEnglishProductLocalization();
  }
})();


/* B2 dynamic homepage selection slider alignment */
(function () {
  function initB2DynamicSelectionSlider() {
    var sliders = document.querySelectorAll('.dynamic-home-selection-slider .products-slider');
    if (!sliders.length || typeof window.loadFlickity !== 'function') return;

    window.loadFlickity().then(function () {
      sliders.forEach(function (slider) {
        var $slider = window.jQuery ? window.jQuery(slider) : null;
        if (!$slider || !$slider.length) return;

        if ($slider.hasClass('flickity-enabled')) {
          $slider.flickity('destroy');
        }

        var productsLimit = Number($slider.data('products-limit')) || 8;
        var productsAvailable = Number($slider.data('products-available')) || productsLimit;
        var hasOverflow = productsAvailable > 4 && productsLimit > 4;

        $slider.flickity({
          lazyLoad: 2,
          imagesLoaded: true,
          draggable: hasOverflow,
          prevNextButtons: hasOverflow,
          wrapAround: hasOverflow,
          cellAlign: 'left',
          pageDots: window.usePageDots,
          contain: true,
          freeScroll: false,
          arrowShape: window.arrowSize,
          initialIndex: 0
        });

        $slider.addClass('slider-initialized');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(initB2DynamicSelectionSlider, 50);
    });
  } else {
    window.setTimeout(initB2DynamicSelectionSlider, 50);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.dynamic-home-selection-slider')) {
      window.setTimeout(initB2DynamicSelectionSlider, 50);
    }
  });
})();
